export default __webpack_public_path__ + "static/media/project-weather.72cd0a1b.jpg";